import config from "../config";
const redirection_url = config.redirection_url;
export const formattingRedirectionUrl = (path) => {
  // Find the index of the first /
  let firstSlashIndex = path.indexOf("/");
  let language = localStorage.getItem("language");
  if (!language) {
    language = "en";
  }
  // Check if there is a / in the URL
  // if (firstSlashIndex !== -1) {
  //   // Remove the first / from the URL
  //   let newUrl =
  //     path.substring(0, firstSlashIndex) + path.substring(firstSlashIndex + 1);
  //     return `${redirection_url}/${language==="fr"?language:""}/${newUrl}`;
  // }
  return `${redirection_url}/${language==="fr"?`${language}/`:""}${path}`;
};
